import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { OutreachState } from '../outreach-state.initial-state';
import { SequenceModeEnum } from '../../../rtk-query/apis/sequence/enums/sequence-mode.enum';

export const setSequenceModeReducers: CaseReducer<OutreachState, PayloadAction<SequenceModeEnum | undefined>> = (state, { payload }) => {
  state.sequenceMode = payload;
};
